import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function NavBar() {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3">
            <Link to="/" className="font-bold text-lg md:text-xl text-gray-800">
              ScalableDeploy
            </Link>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center gap-4">
            <Link to="/shopify" className="text-sm hover:underline text-gray-700">
              Shopify
            </Link>

            <Link to="/demo/rag" className="text-sm hover:underline text-gray-700">
              Demo
            </Link>

            <Link
              to="/trial"
              className="px-3 py-2 text-sm font-medium text-white bg-indigo-600 rounded hover:bg-indigo-700"
            >
              Start free trial
            </Link>
          </div>

          {/* Mobile hamburger */}
          <div className="md:hidden">
            <button
              onClick={() => setOpen((v) => !v)}
              aria-expanded={open}
              aria-label="Toggle navigation"
              className="p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              {open ? (
                <svg className="w-6 h-6 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-6 h-6 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`${open ? 'block' : 'hidden'} md:hidden pb-4`}>
          <div className="space-y-2">
            <Link
              to="/shopify"
              onClick={closeMenu}
              className="block px-3 py-2 rounded hover:bg-gray-50 text-gray-700"
            >
              Shopify
            </Link>

            <Link
              to="/demo/rag"
              onClick={closeMenu}
              className="block px-3 py-2 rounded hover:bg-gray-50 text-gray-700"
            >
              Demo
            </Link>

            <Link
              to="/trial"
              onClick={closeMenu}
              className="block px-3 py-2 rounded bg-indigo-600 text-white text-center font-medium hover:bg-indigo-700"
            >
              Start free trial
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}